// useStore
// Features:
// - Manages global UI state and interaction flags
// - Handles settings (sound, lights, hints)
// - Tracks interactive object hits (raycasting results)

import { create } from 'zustand'

export const useStore = create((set) => ({
    // --- Global Settings ---
    isSoundOn: true,
    toggleSound: () => set((state) => ({ isSoundOn: !state.isSoundOn })),

    // --- Interaction / Raycasting ---
    currentHitName: null,
    setCurrentHitName: (name) => set({ currentHitName: name || null }),

    currentOutsideHitName: null,
    setCurrentOutsideHitName: (name) =>
        set({ currentOutsideHitName: name || null }),

    // --- Camera / Controls ---
    parallaxEnabled: true,
    setParallaxEnabled: (enabled) => set({ parallaxEnabled: enabled }),

    // Pointer lock (camera free look) state
    isPointerLocked: false,
    setPointerLocked: (locked) => set({ isPointerLocked: !!locked }),

    // Character controls gate (WASD enabled/disabled)
    characterControlsEnabled: true,
    setCharacterControlsEnabled: (enabled) =>
        set({ characterControlsEnabled: !!enabled }),

    // --- UI Visibility ---
    // Crosshair visibility (driven by interaction logic)
    crosshairOn: false,
    setCrosshairOn: (on) => set({ crosshairOn: !!on }),

    // Global UI gate (hints, crosshair, etc.)
    uiOn: true,
    setUiOn: (on) => set({ uiOn: !!on }),
    toggleUiOn: () => set((state) => ({ uiOn: !state.uiOn })),

    // Hints visibility toggle
    hintsHidden: false,
    setHintsHidden: (hidden) => set({ hintsHidden: !!hidden }),
    toggleHintsHidden: () =>
        set((state) => ({ hintsHidden: !state.hintsHidden })),

    // --- Props State (Cabin Interior) ---
    // Ceiling/Room lights
    lightsOn: true,
    setLightsOn: (on) => set({ lightsOn: !!on }),
    toggleLights: () => set((state) => ({ lightsOn: !state.lightsOn })),

    // Table lamp
    lampOn: true,
    setLampOn: (on) => set({ lampOn: !!on }),
    toggleLamp: () => set((state) => ({ lampOn: !state.lampOn })),

    // Candle
    candleOn: false,
    setCandleOn: (on) => set({ candleOn: !!on }),
    toggleCandle: () => set((state) => ({ candleOn: !state.candleOn })),
}))
